export default __webpack_public_path__ + "static/media/circle.77bd2ed1.svg";